import { supabase } from '../supabase/supabase';

const callRpc = async (name, params) => {
  const { data, error } = await supabase.rpc(name, params);
  if (error) throw error;
  return data;
};

const readFunctionError = async (error, fallback) => {
  let message = error.message;
  try {
    const response = await error.context?.json?.();
    message = response?.error || message;
  } catch {
    // Use the Functions client message when the response has no JSON body.
  }
  return new Error(message || fallback);
};

const callAccountFunction = async (body) => {
  const { data, error } = await supabase.functions.invoke(
    'admin-create-customer-service-account',
    { body }
  );

  if (error) throw await readFunctionError(error, 'Unable to manage the customer-service account.');
  if (data?.error) throw new Error(data.error);
  return data;
};

export const fetchCustomerServiceCases = () =>
  callRpc('customer_service_get_cases_1793056000000');

export const fetchMyDisputeRequests = () =>
  callRpc('customer_service_get_own_requests_1793056000000');

export const submitDisputeRequest = (request) =>
  callRpc('customer_service_create_resolution_request_1793056000000', {
    p_dispute_id: request.disputeId,
    p_recommendation: request.recommendation,
    p_recommended_refund_cents: request.refundCents,
    p_message: request.message
  });

export const fetchCustomerServiceUsers = async () => {
  const data = await callAccountFunction({ action: 'list' });
  return data.users || [];
};

export const searchUsersForCustomerServiceAccess = async (query) => {
  const data = await callAccountFunction({ action: 'search_users', query });
  return data.users || [];
};

export const setCustomerServiceRole = (userId, enabled) =>
  callRpc('admin_set_customer_service_role_1793056000000', {
    p_user_id: userId,
    p_enabled: enabled
  });

export const createCustomerServiceAccount = ({ name, email }) =>
  callAccountFunction({
    action: 'create',
    name: name.trim(),
    email: email.trim()
  });

export const regenerateCustomerServicePassword = (userId) =>
  callAccountFunction({
    action: 'regenerate_password',
    user_id: userId
  });

export const deleteCustomerServiceAccount = ({ userId, email, pin }) =>
  supabase.functions.invoke('admin-delete-user', {
    body: {
      user_id: userId,
      confirmation_email: email.trim(),
      pin,
      confirmation_text: 'DELETE'
    }
  }).then(async ({ data, error }) => {
    if (error) throw await readFunctionError(error, 'Unable to delete the customer-service account.');
    if (data?.error) throw new Error(data.error);
    return data;
  });

export const fetchDisputeResolutionRequests = () =>
  callRpc('admin_get_customer_service_requests_1793056000000');

export const decideDisputeRequest = (requestId, decision, note) =>
  callRpc('admin_decide_customer_service_request_1793056000000', {
    p_request_id: requestId,
    p_decision: decision,
    p_decision_note: note
  });
